import { MainArea, Page } from '@salecycle/ui-component-library';
import * as React from 'react';
import { OffsiteCampaignsListProvider } from './context/UseOffsiteCampaignsListContext';
import OffsiteCampaignsList from './OffsiteCampaignsList';

export const OffsiteCampaignsListWizardPage: React.FC = () => (
  <OffsiteCampaignsListProvider>
    <MainArea>
      <Page padding={0}>
        <OffsiteCampaignsList />
      </Page>
    </MainArea>
  </OffsiteCampaignsListProvider>
);

export default OffsiteCampaignsListWizardPage;
